import { mapToDateTime } from '@/utils/date-time-utils'

import type ApiClient from '../lib/ApiClient'
import type {
  GameEntryDetailResponse,
  GameEntryOverviewResponse,
} from '../lib/ApiClient.types'
import { createLogger } from '../lib/log'

const { log } = createLogger('InstantGameEntryService')

export default class InstantGameEntryService {
  constructor(private apiClient: ApiClient) {}

  async getEntries(page: number = 1) {
    log('getEntries()')
    const dto = await this.apiClient.get<GameEntryOverviewResponse>(
      `/entries?page=${page}`,
      { auth: true }
    )
    return this.entryListFromDto(dto)
  }

  async getEntryCodes(id: string, page: number = 1) {
    log('getEntryCodes()', id)
    const dto = await this.apiClient.get<GameEntryDetailResponse>(
      `/draws/${id}/entries?current_page=${page}`,
      { auth: true }
    )
    return mapToDateTime(dto)
  }

  private entryListFromDto(data: GameEntryOverviewResponse) {
    return {
      ...data,
      items: mapToDateTime(data.items),
    }
  }
}
